// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"SuperAdminDashboardComponent_hidescrollbar__AJJpM"};